import { Play } from "lucide-react";
import { T } from "../../styles/GlobalStyles";

/** Bandeau persistant — séance live en pause, visible partout sauf sur la page live elle-même. */
export default function LiveBanner({ workoutTitle, clientName, onResume }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 20px",
        background: `${T.accent}1a`,
        borderBottom: `1px solid ${T.accent}40`,
        flexShrink: 0,
      }}
    >
      <span
        style={{
          width: 10,
          height: 10,
          borderRadius: 999,
          background: T.accent,
          flexShrink: 0,
          animation: "softPulse 2s ease-in-out infinite",
        }}
      />
      <span style={{ fontSize: 13, color: T.text, flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        Séance en cours{workoutTitle ? ` — ${workoutTitle}` : ""}
        {clientName ? ` · ${clientName}` : ""}
      </span>
      <button
        type="button"
        onClick={onResume}
        style={{
          height: 32,
          padding: "0 14px",
          borderRadius: 999,
          border: "none",
          background: T.accent,
          color: T.bg,
          fontWeight: 700,
          fontSize: 12,
          display: "flex",
          alignItems: "center",
          gap: 6,
          cursor: "pointer",
          flexShrink: 0,
        }}
      >
        <Play size={12} fill={T.bg} />
        Reprendre
      </button>
    </div>
  );
}
